<div style="padding: 0 30px" [perfectScrollbar]>
  <h1 style="margin: 20px 0 20px">Comments</h1>

  <div>
    <label style="float: left; margin: 0 10px 0 0" class="switch switch-pill switch-success"
      ><input [(ngModel)]="showOnlyReviewersComments" class="switch-input" type="checkbox" /><span
        class="switch-slider"></span
    ></label>
    <div style="float: left; font-weight: 500">Show only reviewer's comments</div>
  </div>

  <br style="clear: both" />
  <div>
    <div *ngFor="let section of filteredComments" [attr.section]="section.label" class="comment-section">
      <h6 style="margin-top: 30px">{{ section.label }}</h6>

      <div
        style="
          background-color: #f7f9fd;
          border-radius: 4px;
          color: #3465c4;
          padding: 15px;
          margin-bottom: 15px;
          display: flex;
        "
        *ngFor="let comment of section.comments"
        [attr.question]="comment.question"
        class="comment-info">
        <div><i class="fa fa-comment"></i></div>
        <div style="flex: 1; padding: 0 20px">
          <p style="font-weight: bold; margin: 0">{{ comment.question }}</p>
          <p style="color: #444; margin: 0; font-size: 13px">{{ comment.text }}</p>
          <p style="color: #444; margin: 0; font-size: 13px">
            Comment added: {{ dateAsString(comment.date) }} / {{ comment.username }}
          </p>
        </div>
        <div style="color: #d6e0f3"><i class="fa fa-chevron-right"></i></div>
      </div>
    </div>
  </div>
</div>
